import { env } from '@/env';
import * as Sentry from '@sentry/react';

export const setupCrashTracking = () => {
  Sentry.init({
    dsn: 'https://fea93ac2f79328b1f8da49b32aec2824@o4506094343421952.ingest.us.sentry.io/4509291942248448',
    environment: env().VITE_ENV,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [env().VITE_HASURA_URL, env().VITE_API_URL],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
};

export const captureException = (err: any) => {
  return Sentry.captureException(err);
};

export function setCrashUser(uid?: string) {
  Sentry.setUser(uid != null ? { id: uid } : null);
}
